import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDetectionExplorerStore } from '../../DetectionExplorerStore'
import {
    DETECTION_EXPLORER_FILTER_DEFINITIONS,
    DETECTION_EXPLORER_FILTER_OPTIONS,
    DetectionExplorerFilterKey
} from '../../config'
import { AddFilterUI } from './AddFilterUI'

export const AddFilterContainer = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const activeFilters = useDetectionExplorerStore((s) => s.activeFilters)
    const addActiveFilter = useDetectionExplorerStore((s) => s.addActiveFilter)
    const menuRef = useRef<HTMLDivElement>(null)

    const availableFilters = useMemo(() => {
        const usedKeys = new Set(activeFilters.map((f) => f.key))
        return DETECTION_EXPLORER_FILTER_OPTIONS.filter((option) => {
            const def = DETECTION_EXPLORER_FILTER_DEFINITIONS[option.value as DetectionExplorerFilterKey]
            return def.allowMultipleChips || !usedKeys.has(def.key)
        })
    }, [activeFilters])

    useEffect(() => {
        if (!isMenuOpen) return
        const onMouseDown = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsMenuOpen(false)
            }
        }
        document.addEventListener('mousedown', onMouseDown)
        return () => document.removeEventListener('mousedown', onMouseDown)
    }, [isMenuOpen])

    const handleAddFilterClick = () => setIsMenuOpen((open) => !open)

    const handleFilterSelect = (value: string) => {
        addActiveFilter(value as DetectionExplorerFilterKey)
        setIsMenuOpen(false)
    }

    return (
        <AddFilterUI
            isMenuOpen={isMenuOpen}
            availableFilters={availableFilters}
            menuRef={menuRef}
            onAddFilterClick={handleAddFilterClick}
            onFilterSelect={handleFilterSelect}
        />
    )
}
